export class IncomeSource {
    constructor(public incomeSourceId: number,
                public incomeSourceName: string)
      { }
  }
